import React from 'react';
import toast from 'react-hot-toast';
import useApi from '../useApi';
import { IResourceRes } from './index.type';

const useAllResource = ({ pageNumber, perpageData, searchKey }: { pageNumber: number; perpageData: number; searchKey: string }) => {
  const [resourceData, setResourceData] = React.useState<IResourceRes | null>(null);

  const { loading: resourceDataLoading, makeApiCall } = useApi({
    url: `/RTM/getfiles?page=${pageNumber}&limit=${perpageData}&search=${searchKey}`,
    method: 'GET',
  });

  const getResourceData = async () => {
    const { response, error } = await makeApiCall<undefined, IResourceRes>();


    if (response?.status === 'success') {
      setResourceData(response); 
    } else {
      setResourceData(null);
    }

    if (error) {
      toast.error('Something went wrong while fetching resource data. Please try again later');
    }
  };

  return {
    resourceData,
    getResourceData,
    resourceDataLoading,
  };
};

export default useAllResource;
